<app-leveltwo [pageName]="'Solar and Seismic New Construction Exclusions'">
    <div heading="General Info" class="General">
      <h3>{{'Solar.PageTitle'|translate}}</h3>

      <h4>{{'Solar.Solar'|translate}}</h4>

      <p>{{'Solar.theinitial'|translate}}</p>
      <p>{{'Solar.theaddition'|translate}}</p>
      <p><b>{{'Solar.Note'|translate}}</b>{{'Solar.anactive'|translate}}</p>

      <!--<button type="button" class="btn btn-primary">{{'Solar.InitialPurchaserButton'|translate}}</button>-->

      <br>

      <h4>{{'Solar.Seismic'|translate}}</h4>

      <p>{{'Solar.Theseismic'|translate}}</p>
      <p>{{'Solar.Theexclusion'|translate}}</p>


    </div>
    <!-- <tab heading="FAQ">FAQ</tab>
    <tab heading="Forms">Forms</tab> -->
</app-leveltwo>
